import { useDynamicViewSchema } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider";
import { getAlertCase, getAlertCaseSummary } from "src/services/alert";
import { AlertWithCase, AlertWithCaseSummary } from "src/types/alert";
import { Case, CaseSummary, CaseVersion } from "src/types/case";

export const useDisplayedAlertCase = (alert: AlertWithCase | null | undefined) => {
  const { defaultAlertVersion } = useDynamicViewSchema();
  const expectedCase = alert ? getAlertCase(alert, defaultAlertVersion) : null;
  const displayedCase = expectedCase ?? alert?.currentCase ?? null;
  const version: CaseVersion =
    !expectedCase || defaultAlertVersion === "current"
      ? "current"
      : defaultAlertVersion === "validation"
      ? "validation"
      : "creation";
  return { expectedCase, displayedCase, version };
};

export const useGetAlertCase = () => {
  const uiSchema = useDynamicViewSchema();
  const defaultAlertVersion = uiSchema.defaultAlertVersion;
  return (alert: AlertWithCase): Case | null => getAlertCase(alert, defaultAlertVersion);
};

export const useGetAlertCaseSummary = () => {
  const uiSchema = useDynamicViewSchema();
  const defaultAlertVersion = uiSchema.defaultAlertVersion;
  return (alert: AlertWithCaseSummary): CaseSummary | null =>
    getAlertCaseSummary(alert, defaultAlertVersion);
};
